// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

body {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

h2 {
  font-size: 1.5rem;
  font-weight: bold;
}

p {
  font-size: 1rem;
  line-height: 1.5em;
}

.crash-message_crash-wrapper_enCKA {
  background-color: var(--menu-bar-background);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.crash-message_body_nF3lY {
  width: 50%;
  color: white;
  text-align: center;
}

/* scratch-www was overriding the colors */

.crash-message_body_nF3lY p,
.crash-message_body_nF3lY h2 {
  color: inherit;
}

.crash-message_reloadButton_lpNpQ {
  border: 2px solid white;
  border-radius: 0.25rem;
  padding: 0.5rem 2rem;
  background: transparent;
  color: white;
  font-weight: bold;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 5px;
}

.crash-message_header_gnVBl {
  font-size: 1.5em;
  font-weight: bold;
}

.crash-message_error-message_vylyd {
  white-space: pre-wrap;
  font-family: monospace;
}
`, "",{"version":3,"sources":["webpack://./src/components/crash-message/crash-message.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA,0CAA0C;;AAE1C;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\nbody {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\nh2 {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\np {\n  font-size: 1rem;\n  line-height: 1.5em;\n}\n\n.crash-wrapper {\n  background-color: var(--menu-bar-background);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.body {\n  width: 50%;\n  color: white;\n  text-align: center;\n}\n\n/* scratch-www was overriding the colors */\n\n.body p,\n.body h2 {\n  color: inherit;\n}\n\n.reloadButton {\n  border: 2px solid white;\n  border-radius: 0.25rem;\n  padding: 0.5rem 2rem;\n  background: transparent;\n  color: white;\n  font-weight: bold;\n  font-size: 0.875rem;\n  cursor: pointer;\n  margin: 5px;\n}\n\n.header {\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n.error-message {\n  white-space: pre-wrap;\n  font-family: monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"crash-wrapper": `crash-message_crash-wrapper_enCKA`,
	"crashWrapper": `crash-message_crash-wrapper_enCKA`,
	"body": `crash-message_body_nF3lY`,
	"reloadButton": `crash-message_reloadButton_lpNpQ`,
	"header": `crash-message_header_gnVBl`,
	"error-message": `crash-message_error-message_vylyd`,
	"errorMessage": `crash-message_error-message_vylyd`
};
export default ___CSS_LOADER_EXPORT___;
